/**
 * Versão vigente dos Termos de Uso renderizados em pages/TermosDeUso.tsx.
 * Enviada no aceite (POST /terms/accept) para registrar qual versão o usuário
 * concordou. Manter em sincronia com o backend (config/terms.js).
 *
 * v2.0 (Fase 6) — plano único: cláusulas novas de uso adequado/suspensão e de
 * assinatura, renovação e cancelamento; escopo do serviço ampliado para
 * redação ENEM e simulados objetivos. Como o backend passou a comparar a
 * versão aceita (`requireTermsAccepted`), este bump força re-aceite de quem
 * havia aceitado a 1.0.
 */
export const CURRENT_TERMS_VERSION = '2.0';

/**
 * Se o usuário precisa (re)aceitar os termos. Fonte única usada pelo modal em
 * App.tsx e pelo gate RequireTermsAccepted — o backend aplica a mesma regra em
 * `middleware/terms.js`, e divergir deixaria o usuário travado em 403 sem
 * modal para resolver.
 */
export function needsTermsAcceptance(
  data: { termsAcceptedAt?: string | null; termsVersion?: string | null } | null
): boolean {
  if (!data) return false;
  if (!data.termsAcceptedAt) return true;
  return data.termsVersion !== CURRENT_TERMS_VERSION;
}
